import React, { useState } from 'react';
import { Form, Input, Button, Alert, Card, Typography } from 'antd';
import { UserOutlined, LockOutlined, TruckOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth'; // Change this import

const { Title, Text } = Typography;

interface LoginForm {
  email: string;
  password: string;
}

const LoginPage: React.FC = () => {
  const [form] = Form.useForm();
  const [error, setError] = useState<string>('');
  const { signIn, isLoading } = useAuth();
  const navigate = useNavigate();

  const onFinish = async (values: LoginForm) => {
    try {
      setError('');
      const result = await signIn(values.email, values.password);
      
      // Redirect after successful login
      if (result?.user?.role === 'super_admin') {
        navigate('/super-admin');
      } else {
        navigate('/admin');
      }

    } catch (err: any) {
      setError(err.message || 'Une erreur est survenue lors de la connexion');
    }
  };

  return (
    <div className="login-container">
      <Card className="login-form-container">
        <div className="login-logo">
          <TruckOutlined style={{ fontSize: '48px', color: '#1890ff' }} />
          <Title level={2} style={{ margin: '16px 0 8px 0' }}>
            FleetBase
          </Title>
          <Text type="secondary">
            Plateforme de gestion de flotte
          </Text>
        </div>

        {error && (
          <Alert
            message="Erreur de connexion"
            description={error}
            type="error"
            showIcon
            style={{ marginBottom: 24 }}
          />
        )}

        <Form
          form={form}
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Veuillez saisir votre email!' },
              { type: 'email', message: 'Format d\'email invalide!' }
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Adresse email"
              autoComplete="email"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: 'Veuillez saisir votre mot de passe!' },
              { min: 6, message: 'Le mot de passe doit faire au moins 6 caractères!' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Mot de passe"
              autoComplete="current-password"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={isLoading}
              block
              style={{ height: '40px' }}
            >
              Se connecter
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: 'center', marginTop: '24px' }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>
            Comptes de démonstration
          </Text>
          <div style={{ marginTop: '8px', fontSize: '12px' }}>
            <div>
              <Text strong>Super Admin:</Text> admin@arkod.fr / SuperAdmin2025!
            </div>
            <div style={{ marginTop: '4px' }}>
              <Text strong>Admin Demo:</Text> admin@demo.fleetbase.com / DemoAdmin2025!
            </div>
          </div>
        </div>

        <div style={{ textAlign: 'center', marginTop: '32px' }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>
            FleetBase v1.0.0 - Développé par Arkod
          </Text>
        </div>
      </Card>
    </div>
  );
};

export default LoginPage;